import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LMLoggerService } from '@services/lm-logger.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LMUrlUtilService } from '@services/utils';

@Injectable()
export class LMHtmlPageUtilService {

  private use3_5 = true;

  constructor(
    private http: HttpClient,
    private lmLoggerService: LMLoggerService,
    private lmUrlUtilService: LMUrlUtilService)  {}

  public getListPersonalizationSpec(url: string): Observable<any> {
    return this.http
      .get(url).pipe(
        catchError(this.handleError));
  }

  public getHtmlPage(url: string): string {
    // let htmlPageSpec = this.http
    // .get(url + (url.lastIndexOf('?') >= 0 ? '&' : '?') + 'output=html')
    // .map(res => res.text())
    // .catch(this.handleError);
    // return htmlPageSpec;

    if (this.use3_5) {
      const paramLoc: number = url.indexOf('?');
      if (paramLoc >= 0) {
        const paramsStr: string = url.substring(paramLoc + 1);
        const params = paramsStr.split('&');
        for (let i = 0; i < params.length; i++) {
          const values = params[i].split('=');
          if (values[0] === 'csk.cli' || values[0] === 'csk.ng') {
            params.splice(i, 1);
          }
        }
        url = url.substring(0, paramLoc);
        if (params.length > 0) {
          url += '?' + params.join('&');
        }
      }

      // adding csk.hidemenubar=true, csk.hidemenubar=true and csk.3x=true so the iframe will render correctly
      url = this.lmUrlUtilService.updateUrlParams(url, {'csk.hidetitlebar': true, 'csk.hidemenubar': true, 'csk.3x': true});
      return url;
    }

    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'output=html'
  }

  public getHtmlPageSpec(url: string): Observable<any> {
    const htmlPageSpec = this.http
      .get(url + (url.lastIndexOf('?') >= 0 ? '&' : '?') + 'fragment=true').pipe(
        catchError(this.handleError));
    return htmlPageSpec;
  }

  public getHtmlPageCode(): Observable<any> {
    const htmlPageCode = this.http
      .get('/hcm/CandidateSelfService/lib/htmlPage/testHtmlPage.html').pipe(
        catchError(error => this.handleError(error)));
    return htmlPageCode;
  }

  public getHtmlPageCss(): Observable<any> {
    const htmlPageCss = this.http
      .get('/hcm/CandidateSelfService/lib/htmlPage/testHtmlPage.css').pipe(
        catchError(error => this.handleError(error)));
    return htmlPageCss;
  }

  public getHtmlPageJs(): Observable<any> {
    const htmlPageJs = this.http
      .get('/hcm/CandidateSelfService/lib/htmlPage/testHtmlPage.js').pipe(
        catchError(error => this.handleError(error)));

    return htmlPageJs;
  }

  private handleError(error: Response) {
    // in a real world app, we may send the error to some remote logging infrastructure
    // instead of just logging it to the console
    this.lmLoggerService.log(error);
    return throwError(error || 'Server error');
  }
}
